import { Variants } from "framer-motion";

export const textFadeUp: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay: number) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: "easeOut", delay },
    }),
};

export const draw: Variants = {
    hidden: { pathLength: 0 },
    visible: (delay: number) => ({
        pathLength: 1,
        transition: { duration: 1.2, ease: "easeOut", delay },
    }),
};

export const circleScale: Variants = {
    hidden: { scale: 0, opacity: 0 },
    visible: (delay: number) => ({
        scale: 1,
        opacity: 1,
        transition: { duration: 0.6, ease: "easeOut", delay },
    }),
};

export const makeRevealDown = (height: number): Variants => ({
    hidden: { height: 0 },
    visible: (delay: number) => ({
        height,
        transition: { duration: 1.0, ease: "easeOut", delay },
    }),
});
